import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Aesthetic%20minimalist%20product%20flat%20lay%20photography%20featuring%20sneakers%20hoodies%20t-shirts%20accessories%20and%20bags%20artfully%20arranged%20on%20a%20clean%20cream%20colored%20surface%20with%20soft%20natural%20daylight%20streaming%20from%20the%20side%20creating%20gentle%20shadows%20editorial%20fashion%20catalog%20style%20with%20muted%20earthy%20tones%20sage%20green%20beige%20and%20warm%20taupe%20color%20palette%20high%20end%20ecommerce%20photography&width=1800&height=1200&seq=hero-bg-2026-x01&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/45" />

      <div className="relative z-10 w-full px-6 md:px-10 pt-20">
        <div className="max-w-4xl mx-auto text-center">
          <div
            className={`transition-all duration-700 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white text-xs font-medium tracking-wider mb-6">
              2026 Updated
            </span>
          </div>

          <h1
            className={`font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-6 transition-all duration-700 delay-100 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            The Ultimate
            <br />
            <span className="italic font-semibold">CSSBuy Spreadsheet</span>
          </h1>

          <p
            className={`text-white/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10 transition-all duration-700 delay-200 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            Discover the most comprehensive and updated <strong>CSSBuy spreadsheet</strong> for 2026.
            Find the best CSSBuy finds across shoes, clothing, accessories, and more &mdash; all organized
            with direct links to help you shop smarter and faster.
          </p>

          <div
            className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-300 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-white text-foreground-950 font-semibold text-sm hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              cssbuy sheet
              <span className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
            <Link
              to="/cssbuy-spreadsheet-guide"
              className="px-8 py-3.5 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read the Full Guide
            </Link>
          </div>

          <div
            className={`mt-14 flex flex-wrap items-center justify-center gap-8 md:gap-12 transition-all duration-700 delay-400 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white font-heading">500+</div>
              <div className="text-xs text-white/60 mt-1">Spreadsheet Links</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white font-heading">15</div>
              <div className="text-xs text-white/60 mt-1">Categories</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white font-heading">Daily</div>
              <div className="text-xs text-white/60 mt-1">Updates</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white font-heading">99%</div>
              <div className="text-xs text-white/60 mt-1">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-white/50">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </span>
      </div>
    </section>
  );
}